import Icon from "external/fortawesome";

export default function DreyfousLocation (){

	return (
        <div className='flex-grow-1 d-flex flex-column form-control'>
            <div className='col-md-12 mb-3'>
                <span className='fn-s-20 fw-bold'>
                    <Icon name='faLocationDot' /> Localización
                </span>
            </div>
            <div className='d-flex flex-grow-1 mb-3'>
                    <iframe
                    className="flex-grow-1"
                        src='https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3787.70929204833!2d-66.08467082397537!3d18.314897975422692!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8c0342fd49b7820d%3A0x8573d2f4d1f2303f!2sDreyfous%20%26%20Associates!5e0!3m2!1ses!2spe!4v1700096369136!5m2!1ses!2spe'
                        style={{ border: '0' }}
                        loading='lazy'
                        referrerPolicy='no-referrer-when-downgrade'
                    ></iframe>
            </div>
            <div className='mb-3 d-grid'>
                <span className='fn-s-20 fw-bold'>
                    <Icon name='faEnvelope' /> Dirección postal
                </span>
                <span> HC-1 Box 29030 PMB 641 Caguas, PR 00725-8900</span>
            </div>
            <div className='mb-3 d-grid'>
                <span className='fn-s-20 fw-bold'>
                    <Icon name='faPhone' /> Teléfono
                </span>
                <span> Oficina (787) 706-2700</span>
            </div>
        </div>
    )
}